import React, { useEffect, useRef, useState } from 'react';
import { getEgressProxyTest, startEgressProxyTest } from '../../../services/egress.service';
import { toUserFacingErrorMessage } from '../../../services/_core';

const POLL_MS = 3000;
const GIVE_UP_MS = 120000;

/**
 * "Test connection": runs through xSPECTRE's egress relay, the same path scans use.
 * Pass `proxyId` for a saved proxy, or `details` ({ scheme, host, port, username, password }).
 */
export default function ProxyTestButton({ orgId, proxyId = '', details = null, disabled = false, label = 'Test connection' }) {
  const [state, setState] = useState({ status: '', text: '' });
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const poll = (testId, startedAt) => {
    timer.current = setTimeout(async () => {
      try {
        const result = await getEgressProxyTest(testId);
        if (result.status === 'PENDING' && Date.now() - startedAt < GIVE_UP_MS) {
          poll(testId, startedAt);
          return;
        }
        if (result.status === 'OK') {
          setState({ status: 'ok', text: `Connected · exit IP ${result.exit_ip}${result.latency_ms ? ` · ${result.latency_ms} ms` : ''}` });
        } else if (result.status === 'PENDING') {
          setState({ status: 'error', text: 'No result yet. Try again in a minute.' });
        } else {
          setState({ status: 'error', text: result.detail || 'Could not connect through the proxy.' });
        }
      } catch (err) {
        setState({ status: 'error', text: toUserFacingErrorMessage(err?.message, 'Could not read the test result.') });
      }
    }, POLL_MS);
  };

  const run = async () => {
    clearTimeout(timer.current);
    setState({ status: 'running', text: 'Testing through xSPECTRE’s scanning network…' });
    try {
      const test = await startEgressProxyTest(orgId, proxyId ? { proxy: proxyId } : details || {});
      poll(test.id, Date.now());
    } catch (err) {
      setState({ status: 'error', text: toUserFacingErrorMessage(err?.message, 'Check the proxy details.') });
    }
  };

  return (
    <span className="scan-network-test">
      <button type="button" className="scan-network-copy" onClick={run} disabled={disabled || state.status === 'running'}>
        {state.status === 'running' ? 'Testing…' : label}
      </button>
      {state.text ? (
        <span className={`scan-network-test-result is-${state.status}`} role="status">
          {state.text}
        </span>
      ) : null}
    </span>
  );
}
